export interface CopyPageRequestDataInterface {
	title: string,
	permalink: string
}

export class CopyPageRequestDataClass implements CopyPageRequestDataInterface {
	title = '';
	permalink = '';
}
